import { PageNotAvailable } from '@porsche-code/kado-ui';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';
import { useAbilityContext } from '@/context';

export const RouteGuard = ({
  can: action,
  a: subject,
  children = <Outlet />,
}: {
  can: string | string[];
  a: string;
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation(NAMESPACES);
  const { state: ability } = useAbilityContext();

  const actions = typeof action === 'string' ? [action] : action;
  if (actions.some((a) => ability.can(a, subject))) {
    return <>{children} </>;
  }

  return <PageNotAvailable text={t('common:pageNotAvailable')} />;
};
